import { BROKER_MAPPING, BROKER_MAPPING_NAME, FIELD_TO_OPTION_KEY } from "../../Constants/TableFilter.constants";
import GenericMappingTable from "./Index";

const ApiBrokerSettings: React.FC = () => (
  <GenericMappingTable
    pageTitle={BROKER_MAPPING}
    entityLabel={BROKER_MAPPING_NAME}
    entityFieldName="API_broker_name"
    selectLabel="Broker"
    selectFieldName={FIELD_TO_OPTION_KEY.broker_name}
    selectDisplayFieldName="broker_name"
    dataApiUrl="/paper-app/api-broker-settings/"
    optionsApiUrl="/paper-app/api-broker-settings-brokers/"
    queryKeyData="api-broker-settings"
    queryKeyOptions="api-broker-list"
  />
);

export default ApiBrokerSettings;